import Axios from 'axios';
import publicIp from 'public-ip';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { UrlBase, UrlBaseServicios, URL_PLUGIN, URL_RETORNO } from 'src/parametros';
import { GET, POST } from 'src/services';
import {
  urlConsultaEstadoSuscripcionPtP,
  urlConsultarPagoPtpPendienteSuscripcion,
  urlHacerPagoSuscripcionPtp,
  urlPagosPendientes,
  urlPagarPendientes
} from 'src/services/urls';
import useCustomToast from 'src/hooks/useCustomToast';
// import useCotizacion from './useCotizacion';

interface Iparams {
  idSuscripcion: string;
  idCotizacion: string;
}


const usePtp = () => {

  const params = useParams<Iparams>();
  const history = useHistory();
  const { addErrorToast, addInfoToast, addSuccessToast, addWarningToast } = useCustomToast();

  const [loading, setLoading] = useState(false);

  const ESTADOS_SUSCRIPCION = {
    RECHAZADO: 'RECHAZADO',
    APROBADO: 'APROBADO',
    PENDIENTE: 'PENDIENTE',
  };

  const ESTADOS_PAGO = {
    RECHAZADO: 'RECHAZADO',
    APROBADO: 'APROBADO',
    PENDIENTE: 'PENDIENTE',
    SIN_PAGOS_PENDIENTES: 'SIN_PAGOS_PENDIENTES',
  };

  const {
    idCotizacion,
    titular,
    producto,
    valoresPagar,
    empPtp,
    broker,
    moneda,
    ivageneral
  } = useSelector((state: any) => state.Cotizacion.cotizacion);

  let agrupacion = 'titular'
  const [datosPersonales] = useState({
    identificacion: titular?.identificacion || titular[agrupacion]?.identificacion,
    cedula: titular?.identificacion || titular[agrupacion]?.identificacion,
    nombre1: `${titular?.nombre1 || titular[agrupacion]?.nombre1}  ${titular?.nombre2 || titular[agrupacion]?.nombre2 || ""}`,
    apellido1: `${titular?.apellido1 || titular[agrupacion]?.apellido1} ${titular?.apellido2 || titular[agrupacion]?.apellido2 || ""}`,
    email: titular?.email || titular[agrupacion]?.email,
    celular: titular?.celular || titular[agrupacion]?.celular
  })

  // const { cotizacion } = useCotizacion();

  const getCambiarSuscripcion = async () => {
    let body = null;
    let URL = null;
    let key = null;

    body = {
      empresa: empPtp,
      cedula: datosPersonales.identificacion,
      nombre: `${datosPersonales.nombre1}`,
      apellido: `${datosPersonales.apellido1}`,
      email: datosPersonales.email,
      celular: datosPersonales.celular, //ESTE PARAMETRO DEBE CUMPLIR CON CIERTA LONGITUD SINO DA ERROR
      idreferencia: idCotizacion,
      descripcion: `${producto.nombre} - #${idCotizacion}`,
      plataforma: 'WEB',
      monto: valoresPagar.total,
      impuestos: valoresPagar.impuestos,
      subtotal: valoresPagar.subtotal,
      montoIva: valoresPagar?.calculos?.IVA,
      cambioSus: true,

      pagIdentificacion: datosPersonales.identificacion,
      pagNombre1: `${datosPersonales.nombre1}`,
      pagApellido1: `${datosPersonales.apellido1}`,
      pagEmail: datosPersonales.email,
      pagCelular: datosPersonales.celular, //ESTE PARAMETRO DEBE CUMPLIR CON CIERTA LONGITUD SINO DA ERROR

      url_retorno: `${URL_RETORNO}fin-cambiosuscripcion/${idCotizacion}/`,
      ipAddress: await publicIp.v4(),
      urlCallback: ``,//${URL_PLUGIN}actualiza-estado-cotizacion&empresa=${broker}&idReferencia=${idCotizacion}`,
      coleccion: 'cotizaciones',
      realizarCobroDolar: true,
    };
    //Cambiar suscripcion
    //URL = `${UrlBase}frontend/web/index.php?r=placetopay/peticion-suscripcion-ptp-generico`;
    URL = `${UrlBaseServicios}placetopay/suscripcion`; // peticion-suscripcion-ptp-generico
    key = 'pagUrl';

    const res = await POST(URL, body);
    /*
      estadoTransaccion: true
      idSuscripcion: "5f4ea04e0abec97d7422534d"
      pagId: "206799"
      pagUrl: "https://test.placetopay.ec/redirection/session/206799/bae256f4d10002464c5db93f882e44f0"
      status: "OK"
      transaccion: true
      transaccionParseo: true
    */
    setLoading(false);
    console.log("RERERERE", res)
    if (res.error && !res?.data?.transaccion) {
      let traEstado = res?.data?.pagEstado;

      // case ESTADOS_PAGO.SIN_PAGOS_PENDIENTES:
      switch (traEstado) {
        case 'P':
          // setEstadoPago(ESTADOS_PAGO.APROBADO);
          addSuccessToast(`Pago aprobado: Ref: ${res?.data?.pagReferencia}`, { autoDismiss: false });
          history.replace(`/ingresarPoliza/${idCotizacion}`);
          break;
        case 'PN':
          addInfoToast(
            'Su pago está siendo procesado, pronto te llegará un mensaje a tu correo para que puedas continuar tu compra', { autoDismiss: false }
          );
          // setEstadoPago(ESTADOS_PAGO.PENDIENTE);
          // resetLoading();
          break;
        case 'R':
          // setEstadoPago(ESTADOS_PAGO.RECHAZADO);

          addErrorToast(`Tu petición de pago ha sido rechazada`, { autoDismiss: false });
          history.push({ pathname: `/paginaPago/${idCotizacion}` });
          // resetLoading();
          break;

        default:
          addWarningToast('Ha ocurrido un problema al consultar el estado del pago', { autoDismiss: false });
        // resetLoading();
      }
      return {
        hasError: res?.data?.errorDescripcion ? res?.data?.errorDescripcion : true
      };
    }
    else if (res.transaccion && !res.error) {
      console.log(res);
      return {
        hasError: false,
        url: res[key],
      };
    } else {
      return {
        hasError: res?.data?.errorDescripcion ? res?.data?.errorDescripcion : true

      };
    }
  }

  const getUrl = async () => {

    let body = null;
    let URL = null;
    let key = null;
    let datosPersonales = {
      identificacion: titular?.identificacion || titular[agrupacion]?.identificacion,
      cedula: titular?.identificacion || titular[agrupacion]?.identificacion,
      nombre1: `${titular?.nombre1 || titular[agrupacion]?.nombre1}  ${titular?.nombre2 || titular[agrupacion]?.nombre1 || ""}`,
      apellido1: `${titular?.apellido1 || titular[agrupacion]?.apellido1} ${titular?.apellido2 || titular[agrupacion]?.apellido1 || ""}`,
      email: titular?.email || titular[agrupacion]?.email,
      celular: titular?.celular || titular[agrupacion]?.celular
    }
    switch (producto.periocidadPago) {
      case 'Unico':
        console.log('VALORES: ', empPtp);
        body = {
          empresa: empPtp,
          adicional: idCotizacion,
          plataforma: 'WEB',
          cliente: {
            cliIdentificacion: datosPersonales.identificacion,
            cliNombre1: datosPersonales.nombre1,
            cliApellido1: datosPersonales.apellido1,
            cliEmail: datosPersonales.email,
            cliCelular: datosPersonales.celular,
          },
          pagador: {
            pagIdentificacion: datosPersonales.identificacion,
            pagNombre1: datosPersonales.nombre1,
            pagApellido1: datosPersonales.apellido1,
            pagEmail: datosPersonales.email,
            pagCelular: datosPersonales.celular,
          },
          imp: valoresPagar.impuestos,
          subt: valoresPagar.subttotal,
          montoIva: valoresPagar?.calculos?.IVA,
          iva12: ivageneral,
          monto: valoresPagar.total,
          descripcion: `${producto.nombre} - #${idCotizacion}`,
          moneda: moneda?.sigla ?? 'USD'
          // urlCallback:
          //'http://localhost/retail/frontend/web/index.php?r=pagos/respuesta-pago&empresa=pnacional&idPedido=5f2515e6b1919144592f7cd3',
        };
        //URL = `${UrlBase}frontend/web/index.php?r=placetopay/peticion-pago-ptp-generico`;
        URL = `${UrlBaseServicios}placetopay/pago`; //peticion-pago-ptp-generico
        key = 'traUrl';
        break;
      case 'Indefinido':
      case 'Mensual':
        body = {
          empresa: empPtp,
          cedula: datosPersonales.identificacion,
          nombre: datosPersonales.nombre1,
          apellido: datosPersonales.apellido1,
          email: datosPersonales.email,
          celular: datosPersonales.celular, //ESTE PARAMETRO DEBE CUMPLIR CON CIERTA LONGITUD SINO DA ERROR
          idreferencia: idCotizacion,
          descripcion: `${producto.nombre} - #${idCotizacion}`,
          plataforma: 'WEB',
          monto: valoresPagar.total,
          impuestos: valoresPagar.impuestos,
          subtotal: valoresPagar.subtotal,
          montoIva: valoresPagar?.calculos?.IVA,

          pagIdentificacion: datosPersonales.identificacion,
          pagNombre1: datosPersonales.nombre1,
          pagApellido1: datosPersonales.apellido1,
          pagEmail: datosPersonales.email,
          pagCelular: datosPersonales.celular, //ESTE PARAMETRO DEBE CUMPLIR CON CIERTA LONGITUD SINO DA ERROR

          url_retorno: `${URL_RETORNO}fin-suscripcion/${idCotizacion}/`,
          ipAddress: await publicIp.v4(),
          urlCallback: `${URL_PLUGIN}actualiza-estado-cotizacion&empresa=${broker}&idReferencia=${idCotizacion}`,
          coleccion: 'cotizaciones',
          realizarCobroDolar: true,
          // moneda:moneda?.sigla ?? 'USD'
        };
        // peticion suscripcion
        //URL = `${UrlBase}frontend/web/index.php?r=placetopay/peticion-suscripcion-ptp-generico`;
        URL = `${UrlBaseServicios}placetopay/suscripcion`; // peticion-suscripcion-ptp-generico
        key = 'pagUrl';
        break;
      default:
        break;
    }

    // console.log("body2:",body,titular)

    // debugger

    let res;
    //
    const data = await Axios.post(URL, body)
    res = data;

    /*
      estadoTransaccion: true
      idSuscripcion: "5f4ea04e0abec97d7422534d"
      pagId: "206799"
      pagUrl: "https://test.placetopay.ec/redirection/session/206799/bae256f4d10002464c5db93f882e44f0"
      status: "OK"
      transaccion: true
      transaccionParseo: true
    */
    setLoading(false);
    console.log("RERERERE", res)
    if (!res?.data?.transaccion) {
      let traEstado = res?.data?.pagEstado;

      // case ESTADOS_PAGO.SIN_PAGOS_PENDIENTES:
      switch (traEstado) {
        case 'P':
          // setEstadoPago(ESTADOS_PAGO.APROBADO);
          addSuccessToast(`Pago aprobado: Ref: ${res?.data?.pagReferencia}`, {
            autoDismiss: false,
          });
          history.replace(`/ingresarPoliza/${idCotizacion}`);
          break;
        case 'PN':
          addInfoToast(
            'Su pago está siendo procesado, pronto te llegará un mensaje a tu correo para que puedas continuar tu compra',
            {
              autoDismiss: false,
            },
          );
          // setEstadoPago(ESTADOS_PAGO.PENDIENTE);
          // resetLoading();
          break;
        case 'R':
          // setEstadoPago(ESTADOS_PAGO.RECHAZADO);

          addErrorToast(`Tu petición de pago ha sido rechazada`, {
            autoDismiss: false,
          });
          history.push({ pathname: `/paginaPago/${idCotizacion}` });
          // resetLoading();
          break;

        default:
          addWarningToast('Ha ocurrido un problema al consultar el estado del pago', { autoDismiss: false });
        // resetLoading();
      }
      return {
        hasError: res?.data?.errorDescripcion || true
      };
    }
    else if (res?.data?.transaccion) {
      console.log(res);
      return {
        hasError: false,
        url: res?.data[key],
      };
    } else {
      return {
        hasError: res?.data?.errorDescripcion || true

      };
    }
  };

  const consultarEstadoSuscripcion = async (idSuscripcion) => {
    const res = await Axios.post(
      urlConsultaEstadoSuscripcionPtP(idSuscripcion),
    );
    console.log("consultarEstadoSuscripcion1111", res)

    if (!res?.data?.transaccion || !res?.data?.traEstado) {

      return {
        // hasError: true,
        hasError: res?.data?.errorDescripcion ? res?.data?.errorDescripcion : true
      };
    }
    const traEstado = res?.data?.traEstado;
    console.log("consultarEstadoSuscripcion", res?.data, traEstado)

    switch (traEstado) {
      case 'P':
      case 'APPROVED':
        return {
          data: res.data,
          estado: ESTADOS_SUSCRIPCION.APROBADO,
        };
      case 'REJECTED':
      case 'FAILED':
        return {
          data: res.data,
          estado: ESTADOS_SUSCRIPCION.RECHAZADO,
        };

      case 'PN':
      case 'PENDING':
        return {
          data: res.data,
          estado: ESTADOS_SUSCRIPCION.PENDIENTE,
        };

      default:
        return null;
    }
  };

  const hacerPrimerPago = async (idSuscripcion) => {
    const body = {
      cliente: {
        cliIdentificacion: datosPersonales.identificacion,
        cliNombre1: datosPersonales.nombre1,
        cliApellido1: datosPersonales.apellido1,
        cliEmail: datosPersonales.email,
      },
      pagador: {
        pagIdentificacion: datosPersonales.identificacion,
        pagNombre1: datosPersonales.nombre1,
        pagApellido1: datosPersonales.apellido1,
        pagEmail: datosPersonales.email,
        pagCelular: datosPersonales.celular,
      },
      totalPagar: valoresPagar.total,
      // numCuota: producto.numeroCuotas,
      numCuota: '1',
      empresa: empPtp,
      intereses: 0,
      // Este ID puede ser una poliza, una cotizacion y más
      id_cotizacion: idCotizacion,
      descripcion: `Primer cobro del seguro: ${producto.nombre}`,
      idSuscripcion: idSuscripcion,
      ipAddress: await publicIp.v4(),
      url_retorno: `${UrlBase}frontend/web/index.php?r=`,
      // Pendiente
      coleccion: 'cotizaciones',
    };




    const resPago = await Axios.post(
      urlHacerPagoSuscripcionPtp,
      JSON.stringify(body),
    );

    //const resPago = await POST(urlHacerPagoSuscripcionPtp, body);

    let status = resPago?.data?.status || resPago?.status;
    console.log("RESPUESTA", resPago.data)
    if (resPago.data.transaccion === false) {
      return {
        hasError: resPago.data.errorDescripcion || true,
      };
    }

    switch (status) {
      case 'P':
      case 'APPROVED':
        return {
          data: resPago.data,
          estado: ESTADOS_PAGO.APROBADO,
        };

      case "R":
      case 'REJECTED':
        return {
          data: resPago.data,
          estado: ESTADOS_PAGO.RECHAZADO,
        };

      case "PN":
      case 'PENDING':
        return {
          data: resPago.data,
          estado: ESTADOS_PAGO.PENDIENTE,
        };

      default:
        break;
    }
  };

  const getPagosPendientes = async () => {
    setLoading(true)
    const res = await Axios.get(`${urlPagosPendientes}${idCotizacion}`)
    console.log("AXIOS", res)
    setLoading(false)
    return res?.data;

  }
  const pagarPagosPendientes = async () => {
    setLoading(true)
    let url = urlPagarPendientes.replace("{cotizacion}", idCotizacion)
    const { idSuscripcion = "" } = params;
    url = `${url}${idSuscripcion}`
    console.log(url)
    let res = { data: {} }
    try {
      res = await Axios.get(url)
      console.log("AXIOS1", res);
    } catch (e) {
      console.log("AXIOS", { ...e });
    }
    setLoading(false)
    return { transaccion: false, errorDescripcion: "", total: 0, ...res.data };

  }

  const consultarEstadoPago = async () => {
    const res = await GET(
      urlConsultarPagoPtpPendienteSuscripcion(idCotizacion, empPtp),
    );

    let traEstado = res?.data?.traEstado || res?.traEstado;

    /*
    if (res?.data?.errorDescripcion === 'No tenemos un pago pendiente.') {
      return {
        estado: ESTADOS_PAGO.PENDIENTE,
      };
    }
  
    if (res.error) {
      return {
        hasError: true,
      };
    }
  */
    // if(res.transaccion)
    // {  
    switch (traEstado) {
      case 'P':
      case 'APPROVED':
      case 'APROBADO':
        return {
          data: { ...res, ...res.data },
          estado: ESTADOS_PAGO.APROBADO,
        };
      case "R":
      case 'REJECTED':
      case 'FAILED':
        return {
          data: { ...res, ...res.data },
          estado: ESTADOS_PAGO.RECHAZADO,
        };

      case "PN":
      case ESTADOS_PAGO.PENDIENTE:
      case ESTADOS_PAGO.SIN_PAGOS_PENDIENTES:
      case 'PENDING':
        return {
          data: { ...res, ...res.data },
          estado: ESTADOS_PAGO.PENDIENTE,
        };

      default:
        if (res?.error) {
          return {
            hasError: true,
          };
        }

        return {
          data: { ...res, ...res.data },
          estado: ESTADOS_PAGO.PENDIENTE,
        };
    }
    // }
    // else
    //   return {
    //     hasError: true,
    //   };
  };

  return {
    getUrl,
    loading,
    consultarEstadoSuscripcion,
    ESTADOS_SUSCRIPCION,
    hacerPrimerPago,
    ESTADOS_PAGO,
    consultarEstadoPago,
    getCambiarSuscripcion,
    getPagosPendientes,
    pagarPagosPendientes
  };
};

export default usePtp;

